(function(){	
    if(typeof APPS === 'undefined'){ APPS = {}; }
    APPS.course = {};    
    /*================================================================================
		Router
	 ================================================================================*/
    var Router = Marionette.AppRouter.extend({
        appRoutes:{
	        //path: given function 
             "earth-science-course":"showEarthScienceCoursePage"
            ,"earth-science-course-downloads":"showEarthScienceCourseDownloadsPage"
            ,"earth-science-course-form":"showEarthScienceCourseFormPage"
            ,"environmental-science-course-downloads":"showEnvironmentalScienceCourseDownloadsPage"
            ,"environmental-science-course-form":"showEnvironmentalScienceCourseFormPage"
        }
    })
    
    /*================================================================================
		Api - called by the Router and through Radio events
	 ================================================================================*/
    var API = {
      showEarthScienceCoursePage:function(e){
            APPS.course.earthScienceCoursePage.show(e);
          }
      ,showEarthScienceCourseDownloadsPage:function(e){
        APPS.course.earthScienceCourseDownloads.show(e);
      }
      ,showEarthScienceCourseFormPage:function(e){
        APPS.course.earthScienceCourseForm.show(e);
      }
      ,showEnvironmentalScienceCourseDownloadsPage:function(e){
        APPS.course.environmentalScienceCourseDownloads.show(e);
      }
      ,showEnvironmentalScienceCourseFormPage:function(e){
        APPS.course.environmentalScienceCourseForm.show(e);
      }
    }
    
    APP.on("before:start",function(){
		new Router({
			controller: API
		})
	})
})();